(function () {
  'use strict';

  const modal = document.getElementById('CartDeliveryExplanationModal');
  if (!modal) return;

  let activeTrigger = null;

  function openModal(trigger) {
    activeTrigger = trigger;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-delivery-modal-open');
    trigger.setAttribute('aria-expanded', 'true');

    document.dispatchEvent(
      new CustomEvent('theme:scroll:lock', {
        bubbles: true,
        detail: modal.querySelector('.cart-delivery-modal__content'),
      })
    );

    window.setTimeout(function () {
      const closeButton = modal.querySelector('.cart-delivery-modal__close');
      if (closeButton) closeButton.focus();
    }, 100);
  }

  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-delivery-modal-open');

    document.dispatchEvent(
      new CustomEvent('theme:scroll:unlock', {
        bubbles: true,
        detail: 400,
      })
    );

    if (activeTrigger) {
      activeTrigger.setAttribute('aria-expanded', 'false');
      activeTrigger.focus();
      activeTrigger = null;
    }
  }

  document.addEventListener('click', function (event) {
    const openTrigger = event.target.closest('[data-cart-delivery-info-open]');
    if (openTrigger) {
      event.preventDefault();
      openModal(openTrigger);
      return;
    }

    if (event.target.closest('[data-cart-delivery-info-close]')) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
      closeModal();
    }
  });
})();
